import { IApiGameAccount } from "ng-league";

export class UpdateGameAccountCtrl {
    public loading: boolean;
    public error: string;
    public editable: boolean;
    public gameAccountName: string;
    public gameAccountLink: string;
    public gameAccountExample: string;
    public gameAccountType: string;
    public gameAccountInput: string;
    public hasIdProvider: boolean;
    public idProvider: string;
    public currentGameAccount: string;
    public isValid: boolean;
    public onUpdateGameAccount: Function;
    public onSuccess: Function;
    public cocPlayerTagInput: string;
    public cocApiKeyInput: string;

    public updateSupercellGameAccount() {
        const gameAccount = `${this.cocPlayerTagInput}@${this.cocApiKeyInput}`.replace(
            /^./,
            match => (match === "#" ? match : `#${match}`)
        );
        this.onUpdateGameAccount({ newGameAccount: gameAccount });
    }

    public updateGameAccount() {
        this.onUpdateGameAccount({ newGameAccount: this.gameAccountInput });
    }

    public handleSuccess(newGameAccount: IApiGameAccount) {
        this.onSuccess({ newGameAccount: newGameAccount });
    }
}
